// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCompanyDetails_scrollable-content__kYwka","card":"ViewCompanyDetails_card__O6a18","ant-card-head-title":"ViewCompanyDetails_ant-card-head-title__Uf7AR"};